import React from "react";

export default function FinanceNoAccess({ message }) {
  return (
    <div className="client-invoices-xero p-4">
      <p className="text-muted mb-0">
        {message ||
          "You do not have permission to access this finance page. Your administrator can grant access via your permission group."}
      </p>
    </div>
  );
}
